export default {
  ruleToRoll: null,
  rolledNewRules: [],
  selectedRule: null,
};
